import { render } from "./PaymentFailed.vue?vue&type=template&id=057b2dd4"
import script from "./PaymentFailed.vue?vue&type=script&lang=js"
export * from "./PaymentFailed.vue?vue&type=script&lang=js"

import "./PaymentFailed.vue?vue&type=style&index=0&id=057b2dd4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__